import { GridView, Menu } from '@mui/icons-material';
import { Stack, Tooltip, ToggleButtonGroup, ToggleButton, Theme } from '@mui/material';
import { useToggleView } from '../../../hooks';
import { CurrentViewType } from '../../../redux/slices/board';
import { EntityType } from '../types';

const CurrentView = ({ entity }: { entity: EntityType }) => {
    const { isBoardView, toggleView } = useToggleView(entity);

    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        selectedView: CurrentViewType[],
      ) => {
        if (selectedView.length === 0) return;
        toggleView(selectedView[0])
    };

    const bgcolor = { 
        bgcolor: (theme: Theme) => theme.palette.primary.light,
        ':hover': {
            bgcolor: (theme: Theme) => theme.palette.primary.light,
        }
    }

    return (
        <Stack
            direction={"row"}
            sx={{
                alignItems: "center",
                gap: 1
            }}>
            <ToggleButtonGroup size="small" onChange={handleChange} aria-label="View Type">
                <Tooltip title="Board View">
                    <ToggleButton sx={isBoardView ? bgcolor : {}} value="board">
                        <GridView color={isBoardView ? "primary" : "action"} />
                    </ToggleButton>
                </Tooltip>
                <Tooltip title="List View">
                    <ToggleButton sx={!isBoardView ? bgcolor : {}} value="list">
                        <Menu color={!isBoardView ? "primary" : "action"} />
                    </ToggleButton>
                </Tooltip>
            </ToggleButtonGroup>
        </Stack>
    )
}

export { CurrentView };